export default __webpack_public_path__ + "static/media/si.4e3a1132.svg";